export function titleCase(str: string): string {
  return str.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}

/** ISO 8601 with or without fractional seconds; null when unparseable. */
export function parseISODate(value: string | null | undefined): Date | null {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

const shortDateTime = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' });
const shortTime = new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' });
const weekdayTime = new Intl.DateTimeFormat(undefined, { weekday: 'short', hour: 'numeric', minute: '2-digit' });

export function formatDateTime(d: Date | null): string {
  return d ? shortDateTime.format(d) : '';
}

export function formatTime(d: Date | null): string {
  return d ? shortTime.format(d) : '';
}

export function formatWeekdayTime(d: Date | null): string {
  return d ? weekdayTime.format(d) : '';
}

export function formatRelative(from: Date, to: Date = new Date()): string {
  const diffSec = Math.round((to.getTime() - from.getTime()) / 1000);
  const abs = Math.abs(diffSec);
  const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });
  if (abs < 60) return rtf.format(-diffSec, 'second');
  if (abs < 3600) return rtf.format(-Math.round(diffSec / 60), 'minute');
  if (abs < 86400) return rtf.format(-Math.round(diffSec / 3600), 'hour');
  return rtf.format(-Math.round(diffSec / 86400), 'day');
}

export function formatNumber(n: number, maximumFractionDigits = 1): string {
  return new Intl.NumberFormat(undefined, { maximumFractionDigits }).format(n);
}

/** Whole hours from now, clamped at zero (GaugeManager.publishCachedGauges). */
export function hoursFromNow(date: Date, now: Date = new Date()): number {
  return Math.max(0, Math.round((date.getTime() - now.getTime()) / 3_600_000));
}
